import { Dispatch, MutableRefObject, SetStateAction, useCallback } from 'react';
import ActionsMenu from '../../../../components/ActionsMenu/ActionsMenu.component';
import { Examiner } from '../../../../models/taskGroup.types';
import { ActionMenuItem } from '../../../../components/ActionsMenu/ActionsMenu.types';
import { getIsExaminerBlocked } from '../../Helpers';
import { PromptDetails } from '../../../../models/promptsTypeModels.types';
import { MessageModal } from '../../ExaminerTreemap.types';

export type UseExaminingTeamMemberActionsMenuProps = {
  setAction: Dispatch<SetStateAction<string>>;
  setIsExaminingTeamChairmen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenEnableExaminerPrompt: React.Dispatch<React.SetStateAction<boolean>>;
  onModalFunctionAction: (data: PromptDetails) => void;
  removedExaminatorFromZeFullNameRef: MutableRefObject<string>;
  removedExaminatorFromZeByTeamMemberIdRef: MutableRefObject<string>;
  setOpenDisableExaminerPrompt: React.Dispatch<React.SetStateAction<boolean>>;
  setMessageModal: React.Dispatch<React.SetStateAction<MessageModal>>;
  setEditExaminerNumberModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const useExaminingTeamMemberActionsMenu = ({
  onModalFunctionAction,
  removedExaminatorFromZeByTeamMemberIdRef,
  removedExaminatorFromZeFullNameRef,
  setAction,
  setIsExaminingTeamChairmen,
  setOpenEnableExaminerPrompt,
  setEditExaminerNumberModalOpen,
  setMessageModal,
  setOpenDisableExaminerPrompt,
}: UseExaminingTeamMemberActionsMenuProps) => {
  const getExaminingTeamMemberActionsMenu = useCallback(
    (examiner: Examiner, assessmentId: string, rowIndex: number) => {
      const menuItems: ActionMenuItem[] = [];

      if (getIsExaminerBlocked(examiner, assessmentId)) {
        menuItems.push({
          text: 'Odblokuj egzaminatora',
          onClick: () => {
            setAction('Odblokuj egzaminatora');
            setIsExaminingTeamChairmen(false);
            setOpenEnableExaminerPrompt(true);
          },
        });
      } else {
        menuItems.push({
          text: 'Zablokuj egzaminatora',
          onClick: () => {
            setAction('Zablokuj egzaminatora');
            setIsExaminingTeamChairmen(false);
            setOpenDisableExaminerPrompt(true);
          },
        });
      }
      menuItems.push({
        text: 'Usuń egzaminatora z ZE',
        onClick: () => {
          setAction('Usuń egzaminatora z ZE');
          onModalFunctionAction({
            fullName: removedExaminatorFromZeFullNameRef.current,
            examinatorId: removedExaminatorFromZeByTeamMemberIdRef.current,
            type: 'confirmation',
            otherText: '',
            groupId: '',
            typePromp: 'ZE',
          });
        },
      });
      menuItems.push({
        text: 'Wyślij wiadomość',
        onClick: () => {
          setAction('Wyślij wiadomość');
          setMessageModal({ open: true, type: 'standard' });
        },
      });
      menuItems.push({
        text: 'Edytuj numer egzaminatora',
        onClick: () => {
          setAction('Edytuj numer egzaminatora');
          setEditExaminerNumberModalOpen(true);
        },
      });
      return <ActionsMenu menuItems={menuItems} rowIndex={rowIndex} />;
    },
    [onModalFunctionAction],
  );

  return {
    getExaminingTeamMemberActionsMenu,
  };
};
